import type { ShouldRevalidateFunction } from "react-router";

/**
 * Paging and filters on list pages live in component state and the query
 * string; the page fetches those itself, so they must not re-run the loader.
 */
export const revalidateOnPathChange: ShouldRevalidateFunction = ({
  currentUrl,
  nextUrl,
  defaultShouldRevalidate,
}) => (currentUrl.pathname !== nextUrl.pathname ? defaultShouldRevalidate : false);
